import { ReactNode } from 'react';
import { DetailPageWithStickyHeader } from '../sticky-detail-header/detail-page-with-sticky-header';
import { DetailHero, DetailHeroProps, coverImageUrl } from './detail-hero';
import { DetailMeta } from './detail-meta';

interface DetailPageProps extends Omit<DetailHeroProps, 'title' | 'cover' | 'backdropUrl'> {
    title: string;
    /* Hero title with links in it; the sticky bar keeps the plain `title`. */
    titleContent?: ReactNode;
    /* Also the backdrop and sticky bar image when a custom `cover` is passed. */
    coverUrl?: string;
    cover?: ReactNode;
    hasStickyHeader?: boolean;
    children?: ReactNode;
}

/** A `DetailHero` and content, with a sticky bar built from the same title, pills and actions. */
export function DetailPage({ title, titleContent, coverUrl, cover, hasStickyHeader = true, children, ...hero }: DetailPageProps) {
    const banner = (
        <DetailHero
            {...hero}
            title={titleContent ?? title}
            backdropUrl={coverUrl}
            cover={cover ?? (coverUrl && (
                <img
                    src={coverImageUrl(coverUrl)}
                    srcSet={`${coverImageUrl(coverUrl, 2)} 2x`}
                    alt={title}
                    draggable={false}
                />
            ))}
        />
    );

    if (!hasStickyHeader) {
        return (
            <>
                {banner}
                {children}
            </>
        );
    }

    return (
        <DetailPageWithStickyHeader
            title={title}
            meta={<DetailMeta pills={hero.pills} size="small" />}
            imageUrl={coverUrl && coverImageUrl(coverUrl)}
            renderActions={() => (
                <>
                    {hero.primaryActions}
                    {hero.secondaryActions}
                </>
            )}
            banner={banner}
        >
            {children}
        </DetailPageWithStickyHeader>
    );
}

export default DetailPage;
